export const getAiUrl = (query) => {
  const params = new URLSearchParams({ returnTo: window.location.href })
  if (query && query.trim())
      params.set('q', query.trim())

  return `${process.env.REACT_APP_AI_URL}?${params.toString()}`
}
